import { createStructuredSelector } from "reselect";
import {
    SUPPLIER_INFO_LIST,
    SUPPLIER_INFO_LIST_SUCCESS,
    SUPPLIER_INFO_LIST_ERROR,
    SUPPLIER_INFO_LIST_SEARCH_SET,
    SUPPLIER_INFO_LIST_SEARCH_CHANGE
} from "../actions";

export const NAME = 'supplierInfo';

export const SupplierInfoList = (filters) => ({
    type: SUPPLIER_INFO_LIST,
    payload: { filters: filters }
});

export const SupplierInfoListSuccess = (data) => ({
    type: SUPPLIER_INFO_LIST_SUCCESS,
    payload: data
});

export const SupplierInfoListError = (error) => ({
    type: SUPPLIER_INFO_LIST_ERROR,
    payload: error
});

export const SupplierInfoListSearchSet = (data) => ({
    type: SUPPLIER_INFO_LIST_SEARCH_SET,
    payload: data
});

export const SupplierInfoListSearchChangeSet = (data) => ({
    type: SUPPLIER_INFO_LIST_SEARCH_CHANGE,
    payload: data
});

const supplierInfo = (state) => state[NAME];

export const SupplierInfoSelector = createStructuredSelector({
    supplierInfo
})
